import {
  FETCH_GATEWAY_TRANSACTION_START,
  FETCH_GATEWAY_TRANSACTION_SUCCESS,
  FETCH_GATEWAY_TRANSACTION_ERROR,
  FETCH_GATEWAY_TRANSACTIONS_START,
  FETCH_GATEWAY_TRANSACTIONS_SUCCESS,
  FETCH_GATEWAY_TRANSACTIONS_ERROR,
  FETCH_GATEWAY_CALLBACKS_START,
  FETCH_GATEWAY_CALLBACKS_SUCCESS,
  FETCH_GATEWAY_CALLBACKS_ERROR,
  FETCH_GATEWAY_SUSPICIOUS_LOGS_START,
  FETCH_GATEWAY_SUSPICIOUS_LOGS_SUCCESS,
  FETCH_GATEWAY_SUSPICIOUS_LOGS_ERROR,
  FETCH_GATEWAY_IPNS_START,
  FETCH_GATEWAY_IPNS_SUCCESS,
  FETCH_GATEWAY_IPNS_ERROR,
  FETCH_GATEWAY_IPN_START,
  FETCH_GATEWAY_IPN_SUCCESS,
  FETCH_GATEWAY_IPN_ERROR,
  DOWNLOAD_IPNS_INIT,
  SHOW_ERROR_MESSAGE,
} from '../../constants/ActionTypes';
import { gatewayAxios } from '../../util/Api';
import { downloadExcel, downloadPDF } from '../../util/download';

export const getGatewayTransactions = (params) => (dispatch) => {
  dispatch({ type: FETCH_GATEWAY_TRANSACTIONS_START });
  gatewayAxios.get(`transactions/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_GATEWAY_TRANSACTIONS_SUCCESS,
      payload: data.data,
      currentPage: Number(headers['content-range'].split('-')[0]),
      totalRecords: Number(headers['content-range'].split('/')[1]),
    });
  }).catch((error) => {
    if (error.response && error.response.data.error) {
      dispatch({ type: FETCH_GATEWAY_TRANSACTIONS_ERROR, payload: error.response.data.error });
    }
    console.error('Error: ', error.message);
  });
};

export const getGatewayTransactionById = (id) => (dispatch) => {
  dispatch({ type: FETCH_GATEWAY_TRANSACTION_START });
  gatewayAxios.get(`/transactions/${id}`).then(({ data }) => {
    dispatch({ type: FETCH_GATEWAY_TRANSACTION_SUCCESS, payload: data.data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: FETCH_GATEWAY_TRANSACTION_ERROR, payload: error.response.data.error });
    }
    console.error('Error: ', error.message);
  });
};

export const getGatewayCallbacks = (params) => (dispatch) => {
  dispatch({ type: FETCH_GATEWAY_CALLBACKS_START });
  gatewayAxios.get(`callbacks/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_GATEWAY_CALLBACKS_SUCCESS,
      payload: data.data,
      currentPage: Number(headers['content-range'].split('-')[0]),
      totalRecords: Number(headers['content-range'].split('/')[1]),
    });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: FETCH_GATEWAY_CALLBACKS_ERROR, payload: error.response.data.error });
    }
    console.error('Error: ', error.message);
  });
};

export const getGatewaySuspiciousLogs = (params) => (dispatch) => {
  dispatch({ type: FETCH_GATEWAY_SUSPICIOUS_LOGS_START });
  gatewayAxios.get(`suspiciousActivities/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_GATEWAY_SUSPICIOUS_LOGS_SUCCESS,
      payload: data.data,
      currentPage: Number(headers['content-range'].split('-')[0]),
      totalRecords: Number(headers['content-range'].split('/')[1]),
    });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: FETCH_GATEWAY_SUSPICIOUS_LOGS_ERROR, payload: error.response.data.error });
    }
    console.error('Error: ', error.message);
  });
};

export const getGatewayIpns = (params) => (dispatch, getState) => {
  dispatch({ type: FETCH_GATEWAY_IPNS_START });
  const processor = getState().common.selectedProcessor;
  gatewayAxios.get(`ipns/${processor}/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_GATEWAY_IPNS_SUCCESS,
      payload: data.data,
      currentPage: Number(headers['content-range'].split('-')[0]),
      totalRecords: Number(headers['content-range'].split('/')[1]),
    });
  }).catch(({ response: { data } }) => {
    if (data.message || data.error) {
      dispatch({ type: FETCH_GATEWAY_IPNS_ERROR, payload: (data.message || data.error) });
    }
  });
};

export const getGatewayIpnById = (id, serviceType) => (dispatch) => {
  dispatch({ type: FETCH_GATEWAY_IPN_START });
  gatewayAxios.get(`ipns/${serviceType}/${id}`).then(({ data }) => {
    dispatch({ type: FETCH_GATEWAY_IPN_SUCCESS, payload: data.data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: FETCH_GATEWAY_IPN_ERROR, payload: error.response.data.error });
    }
    console.error('Error: ', error.message);
  });
};

export const downloadRecords = (params, type) => (dispatch, getState) => {
  dispatch({ type: DOWNLOAD_IPNS_INIT });
  const processor = getState().common.selectedProcessor;
  gatewayAxios.get(`ipns/${processor}/${params ? `?${params}` : ''}`).then((response) => {
    const columns = [
      { title: 'Date', dataIndex: 'created_at' },
      { title: 'Account', dataIndex: 'account' },
      { title: 'Amount', dataIndex: 'amount' },
      { title: 'Currency', dataIndex: 'currency' },
      { title: 'Status', dataIndex: 'status' },
      { title: 'Type', dataIndex: 'transaction_type' },
      { title: 'Kitegateway reference', dataIndex: 'kitegateway_reference' },
      { title: 'Processor Reference', dataIndex: 'processor_reference' },
    ];
    if (type === 'pdf') {
      downloadPDF(response.data, columns, 'IPNs');
    } else {
      downloadExcel(response.data, columns, 'IPNs');
    }
  }).catch((error) => {
    dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'Error!' });
  });
};

export default {
  getGatewayTransactions,
  getGatewayCallbacks,
};
